import * as Sentry from '@sentry/nuxt'
import { useEnvironment } from '#imports'

const { environment } = useEnvironment()
const config = useRuntimeConfig()

Sentry.init({
	dsn: config.public.glitchtip.dsn,
	environment: environment || 'development',

	// Enable automatic breadcrumbs
	integrations: [
		Sentry.breadcrumbsIntegration({
			console: true, // Capture console.log, console.warn, console.error
			dom: true, // Capture DOM events (clicks, inputs)
			fetch: true, // Capture fetch/XHR requests
			history: true, // Capture navigation history
		}),
	],

	// Process events before sending to GlitchTip
	beforeBreadcrumb(breadcrumb) {
		// Prettify console logs with objects
		if (breadcrumb.category === 'console' && breadcrumb.data?.arguments) {
			// Format the message with prettified objects
			breadcrumb.message = breadcrumb.data.arguments
				.map((arg: unknown) => {
					if (typeof arg === 'object' && arg !== null) {
						try {
							return JSON.stringify(arg, null, 2)
						} catch {
							return String(arg)
						}
					}
					return String(arg)
				})
				.join(' ')
		}
		return breadcrumb
	},

	// Capture console errors automatically
	beforeSend(event) {
		// You can filter events here if needed
		return event
	},
})
